import { useEffect, useMemo, useState } from "react"
import { useFilter } from "../../../context/FIlterContext";
import { Urls } from "../../../services/Urls";
import services from "../../../services/services";
import _ from "underscore";

export const useIssueTypeSummary = () => {
    const { projectFilter, setProjectFilter } = useFilter();
    const [issueTypeData, setIssueTypeData] = useState([]);
    const [loader, setLoader] = useState(false);
    const [noData, setNoData] = useState([])

    useEffect(() => {
        if (projectFilter?.apiCall) {
            getIssueTypeSummaryData();
        }
    }, [projectFilter?.apiCall]);


    const getIssueTypeSummaryData = async () => {
        try {
            setLoader(true)
            const payload = {
                "client_id": projectFilter?.client_id?.client_id || 0,
                "project_ids": _.pluck(projectFilter?.project_ids, 'project_id')?.toString(),
                "lead_user_code": projectFilter?.lead_user_code?.user_code || 0,
                "request_user_code": projectFilter?.request_user_code || 0,
                "project_module_ids": _.pluck(projectFilter?.project_module_ids, 'option_id')?.toString(),
                "feature_ids": _.pluck(projectFilter.feature_ids, 'issue_id')?.toString(),
                "issue_key": projectFilter?.issue_id,
                "month": new Date().getMonth() + 1,
                "year": new Date().getFullYear(),
                "number_of_month": new Date().getMonth() + 1
            }
            const res = await services.getInvokeRemote('POST', Urls('GETPROJECTWORKLOGTRENDSUMMARY'), payload)
            if (res?.status === 200) {
                let data = res?.body?.data?.project_worklog_trend_summary
                data = data.map((item) => {
                    item["sliced_month"] = item?.log_month_name?.slice(0, 3);
                    return item;
                })
                if (!_.isEmpty(data)) {
                    setNoData(false);
                } else {
                    setNoData(true);
                }
                const issueTypes = _.uniq(_.pluck(data, "issue_type_group_name"));
                let arr = [];
                issueTypes?.forEach((item) => {
                    let obj = {
                        name: item,
                        data: []
                    }
                    _.uniq(_.pluck(data, "log_month_name"))?.forEach((month) => {
                        const findData = _.findWhere(data, { log_month_name: month, issue_type_group_name: item });
                        if (!_.isEmpty(findData)) {
                            obj.data.push(findData?.log_hours !== null ? findData?.log_hours : 0);
                        } else {
                            obj.data.push(0);
                        }
                    })
                    if (_.isEmpty(_.findWhere(arr, { name: item }))) {
                        arr.push(obj);
                    }
                })
                const months = _.uniq(_.pluck(data, "sliced_month"))?.slice(1);
                arr?.map((item) => {
                    item.data = item?.data?.slice(1);
                    return item;
                })
                const allYValues = arr.flatMap(series => series.data).filter(val => typeof val === 'number');
                const array = _.pluck(arr, "data");
                const arrrr = Array.from({ length: allYValues?.length }, (_, i) =>
                    array?.reduce((sum, arr) => sum + (arr[i] || 0), 0)
                );

                const min = Math.min(...arrrr);
                const max = Math.max(...arrrr);
                const tickInterval = Math.ceil(((max - min) / 4));
                setIssueTypeData({ x_axis: months, y_axis: arr, api_data: data, min, max, tickInterval });
                setProjectFilter((prev) => ({ ...prev, apiCall: false }))
            }
            setLoader(false)
        } catch (error) {
            setLoader(false)
            setProjectFilter((prev) => ({ ...prev, apiCall: false }))
            console.error('Error :', error);
        }
    }

    const formatTooltip = (thisVal) => {
        let data = _.findWhere(issueTypeData?.api_data, { issue_type_group_name: thisVal.series.name, sliced_month: issueTypeData?.x_axis?.[thisVal.point.x] });
        let percent = 0;
        let state = "";
        let color = "";
        percent = data?.previous_month_compare_percentage;
        if (percent === null) {
            percent = "";
            state = "";
            color = "";
        } else {
            color = percent >= 100.00 ? "green" : "red";
            state = percent >= 100.00 ? "up" : "down";
        }
        const compare = percent !== "" ? parseFloat(percent >= 100.00 ? percent - 100.00 : 100.00 - percent)?.toFixed(2) : "";
        return `<div><span style="color:${thisVal.color};">\u25CF</span><span style="font-size:10px;">${thisVal?.series?.name}</span><br/>Prev. month: <b style="color: ${color}">${compare !== "" ? (compare + "%") : ""}${state === "up" ? "▲" : (state === "down" ? "▼" : "")}</b></div><br/>Log Hours: <b>${thisVal.point.y}</b>`;
    }

    const options = {
        credits: { enabled: false },
        chart: {
            type: 'column'
        },
        title: {
            text: ''
        },
        xAxis: {
            categories: issueTypeData?.x_axis
        },
        yAxis: {
            min: issueTypeData?.min,
            max: issueTypeData?.max,
            tickInterval: issueTypeData?.tickInterval,
            title: { text: 'Log Hours' }
        },
        tooltip: {
            formatter: function () {
                const returnedVal = formatTooltip(this);
                return returnedVal;
            }
        },
        plotOptions: {
            column: {
                stacking: 'normal',
                cursor: 'pointer',
                allowPointSelect: false,
                dataLabels: {
                    enabled: true,
                    formatter: function () {
                        if (this.y > 0) {
                            return `<span>${this.y}</span>`;
                        } else {
                            return null;
                        }
                    }
                },
            }
        },
        series: issueTypeData?.y_axis,
        legend: {
            layout: 'horizontal',
            align: 'center',
            verticalAlign: 'top'
        },
    }

    return useMemo(() => ({
        loader, options, noData
    }), [loader, options, noData]);
}